module.exports = __webpack_public_path__ + "static/media/Insu.74dfd512.png";